import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// const rootMenus = [
//   { name: '首页', path: '/home' },
//   { name: '运行管理', path: 'run' },
//   { name: '缺陷管理', path: 'defect' },
//   { name: '隐患管理', path: 'hidden' }
// ]

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('token') || '',
    userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {},
    rootMenu: JSON.parse(sessionStorage.getItem('rootMenu')) || {}, // 选中的根菜单
    rootMenus: JSON.parse(sessionStorage.getItem('rootMenus')) || [], // 根菜单数组
    tabs: JSON.parse(sessionStorage.getItem('tabs')) || [],
    allMenus: JSON.parse(sessionStorage.getItem('allMenus')) || [], // 所有菜单
    path: JSON.parse(localStorage.getItem('path')) || [],
    leafMenu: JSON.parse(sessionStorage.getItem('leafMenu')) || {},
    mainStyle: {
      top: '0px',
      bottom: '0px',
      left: '0px',
      right: '0px'
    },
    permissions: JSON.parse(sessionStorage.getItem('permissions')) || []
  },
  getters: {
    sideMenus (state) {
      let subMenus = state.allMenus.find(item => item.path === state.rootMenu.path)
      if (subMenus && subMenus.children) {
        return subMenus.children
      } else {
        return []
      }
    }
  },
  mutations: {
    setMainStyle (state, style) {
      state.mainStyle = style
    },
    addTab (state, tab) {
      if (!state.tabs.some(item => item.leafMenu.path === tab.leafMenu.path)) {
        if (state.tabs.length >= 15) {
          state.tabs.splice(0, 1)
        }
        state.tabs.push(tab)
        sessionStorage.setItem('tabs', JSON.stringify(state.tabs))
      }
    },
    removeTab (state, index) {
      state.tabs.splice(index, 1)
      sessionStorage.setItem('tabs', JSON.stringify(state.tabs))
    },
    setTabs (state, tabs) {
      state.tabs = tabs
      sessionStorage.setItem('tabs', JSON.stringify(state.tabs))
    },
    setToken (state, token) {
      state.token = token
      sessionStorage.setItem('token', token)
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    setRootMenu (state, rootMenu) {
      state.rootMenu = rootMenu
      sessionStorage.setItem('rootMenu', JSON.stringify(rootMenu))
    },
    setRootMenus (state, rootMenus) {
      state.rootMenus = rootMenus
      sessionStorage.setItem('rootMenus', JSON.stringify(rootMenus))
    },
    setAllMenus (state, allMenus) {
      state.allMenus = allMenus
      sessionStorage.setItem('allMenus', JSON.stringify(allMenus))
    },
    setPath (state, path) {
      state.path = path
      sessionStorage.setItem('path', JSON.stringify(path))
    },
    clear (state) {
      state.token = ''
      state.userInfo = {}
      sessionStorage.clear()
    },
    setLeafMenu (state, leafMenu) {
      state.leafMenu = leafMenu
      sessionStorage.setItem('leafMenu', JSON.stringify(leafMenu))
    },
    setPermissions (state, ps) {
      state.permissions = ps
      sessionStorage.setItem('permissions', JSON.stringify(ps))
    }
  },
  actions: {
  },
  modules: {
  }
})
